import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { scrollBar } from 'styles/theme'
import CopilotSettings from './CopilotSettings/CopilotSettings'
import CopilotInsights from './CopilotInsights/CopilotInsights'
import { useSelector } from 'react-redux'
import PatientCopilotNeedsAttentionWidget from './NeedsAttention/PatientCopilotNeedsAttentionWidget'

const useStyles = makeStyles(theme => ({
  patientCopilotRoot: {
    background: 'white',
    height: '100%',
    overflowY: 'scroll',
    padding: '20px 24px',
    ...scrollBar
  }
}))

const PatientCopilot = () => {
  const classes = useStyles()

  const { id: patientId } = useSelector(state => state.patientsReducer.patient)
  const analyticsPayload = {
    patientId
  }

  return (
    <div className={classes.patientCopilotRoot}>
      <PatientCopilotNeedsAttentionWidget />
      <CopilotSettings analyticsPayload={analyticsPayload} />
      <div style={{ marginTop: 20 }}>
        <CopilotInsights />
      </div>
    </div>
  )
}

export default PatientCopilot
